import { type TIntegrationCategory } from '~/models/Unified';
import { META_CATEGORIES } from './categories';
import { INTEGRATION_CATEGORIES } from './integrations';

export type TCategoryPage = {
    slug: string;
    kind: 'meta' | 'api';
    name: string;
    data_type: string;
    seo_description: string;
    filterCategories: TIntegrationCategory[];
};

export function getCategoryPage(slug: string): TCategoryPage | null {
    if (slug in META_CATEGORIES) {
        const meta = META_CATEGORIES[slug as keyof typeof META_CATEGORIES];
        return {
            slug,
            kind: 'meta',
            name: meta.name,
            data_type: meta.data_type,
            seo_description: meta.seo_description,
            filterCategories: [...meta.categories],
        };
    }

    if (slug in INTEGRATION_CATEGORIES) {
        const api = INTEGRATION_CATEGORIES[slug as keyof typeof INTEGRATION_CATEGORIES];
        return {
            slug,
            kind: 'api',
            name: api.name,
            data_type: api.data_type,
            seo_description: `One Unified API to read and write ${api.name} data in real-time. Launch native integrations 100x faster. You won't have to manage maintenance, manually sync data, or handle authorization. `,
            filterCategories: [(slug === 'scim' ? 'hris' : slug) as TIntegrationCategory],
        };
    }

    return null;
}
